const CONSENT_KEY = 'storyseed_parent_consent';
const CONSENT_VERSION = '1.0';

interface ConsentRecord {
  version: string;
  timestamp: string;
  parentVerified: boolean;
}

export function hasParentConsent(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) return false;
    const record: ConsentRecord = JSON.parse(stored);
    return record.version === CONSENT_VERSION && record.parentVerified;
  } catch {
    return false;
  }
}

export function grantParentConsent(): void {
  const record: ConsentRecord = {
    version: CONSENT_VERSION,
    timestamp: new Date().toISOString(),
    parentVerified: true,
  };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(record));
}

export function revokeConsent(): void {
  localStorage.removeItem(CONSENT_KEY);
}

export function clearAllData(): void {
  localStorage.removeItem(CONSENT_KEY);
  localStorage.removeItem('storyseed_stories');
}
